import React from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import {
    PlaydateInvite,
    ResponseType,
    User,
} from "../../../gql/types";
import ActionButton from "../../button/ActionButton";
import UnderlineButton from "../../button/UnderlineButton";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import PlaydateInviteConfirmedDetails from "../PlaydateInviteConfirmedDetails";

export type PlaydateInviteConfirmedRecipientViewProps = {
    user?: User;
    onBack: () => void;
    onAccept: () => void;
    onReject: () => void;
    onCreate?: () => void;
    invite: PlaydateInvite;
    baseZIndex?: number;
};

const PlaydateInviteConfirmedRecipientView: React.FC<PlaydateInviteConfirmedRecipientViewProps> = ({
    user,
    onBack,
    onAccept,
    onReject,
    onCreate,
    invite,
    baseZIndex,
}) => {
    const response = invite.viewerResponse;

    const infoText = invite.expired
        ? "This playdate already happened! Feel free to review the details."
        : "Please review the finalized playdate details.";

    const rejectStr = (!response || response === null)
        ? "We can't make it"
        : "We can no longer make it";

    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Playdate Invite Details"
            infoText={infoText}
            topIcon="happy"
        >
            <PlaydateInviteConfirmedDetails
                invite={invite}
                user={user}
            />
            <div className={styles.buttonContainer}>
                {!invite.expired && <>
                    {((response && response !== null && response.responseType !== ResponseType.Accept) || !response) && <ActionButton
                        onClick={onAccept}
                    >
                        We'd love to join!
                    </ActionButton>}
                    {(!response || response === null || response.responseType !== ResponseType.Reject) && <ActionButton
                        onClick={onReject}
                    >
                        {rejectStr}
                    </ActionButton>}
                    <UnderlineButton onClick={onBack}>
                        Back
                    </UnderlineButton>
                </>}
                {invite.expired && (
                    onCreate ? <>
                        <ActionButton
                            onClick={onCreate ?? onBack}
                        >
                            Create New Invite
                        </ActionButton>
                    </> :
                        <ActionButton
                            onClick={onBack}
                        >
                            Back
                        </ActionButton>
                )}
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteConfirmedRecipientView;
